import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import "../styles/aboutUs.scss"
import "../styles/clients.scss"
import PageHero from "../components/PageHero"
import Whyus from "../components/Whyus"
import News from "../components/News"
import Clients from "../components/Clients"
import leaderImg from "../images/about/a6eab89a.png"
import leaderImg1 from "../images/about/1736166809764.jpeg"
import leaderImg2 from "../images/about/1767898530659.jpeg"

const LEADERS = [
  {
    name: "Dr. Muhammad Tauseef Yunis",
    credentials: "PhD, PMP, LMC",
    title: "CEO & Co-Founder",
    linkedin: "https://www.linkedin.com/in/dr-muhammad-tauseef-yunis-phd-pmp-lmc-a4973511/",
    img: leaderImg,
  },
  {
    name: "Hasan Arif",
    credentials: "",
    title: "COO & Co-Founder",
    linkedin: "https://www.linkedin.com/in/hasan-visiomate/",
    img: leaderImg1,
  },
  {
    name: "Rabi Ullah Khan",
    credentials: "Coach, Therapist",
    title: "CHRO",
    linkedin: "https://www.linkedin.com/in/rabiullahkhann/",
    img: leaderImg2,
  },
]

const LinkedInIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
)

const About = ({ data }) => {
  return (
    <Layout pageTitle={"Visiomate - About Visiomate"}
    descrip = {"Learn about Visiomate expertise, experience, and commitment to providing innovative solutions."}>
      <PageHero eyebrow="About Us" title="We take immense pride in our commitment to shaping the future for our clients" description="Ensuring their journey is innovatively crafted and purposefully designed." />
      {/* Mission & Vision */}
      <section className="ab-mission-vision">
        <div className="ab-mv-inner">
          {/* <div className="ab-mv-about">
            <h2>About Us</h2>
            <p>Visiomate was established by seasoned professionals with extensive expertise in developing large-scale software, establishing web and desktop-based systems for businesses, and navigating IT advancements across diverse industries since 2018.</p>
            <button className="ab-mv-readmore">Read More</button>
          </div> */}
          <div className="ab-mv-cards">
            <div className="ab-mv-card">
              <div className="ab-mv-icon-wrap">
                <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
                  <circle cx="26" cy="26" r="22" fill="#f0cd17" opacity="0.25"/>
                  <circle cx="26" cy="26" r="14" fill="#f0cd17" opacity="0.5"/>
                  <circle cx="26" cy="26" r="7"  fill="#f0cd17"/>
                  <line x1="44" y1="8" x2="26" y2="26" stroke="#1b2d8e" strokeWidth="2.5" strokeLinecap="round"/>
                  <polyline points="44,8 44,16 36,8" fill="#1b2d8e" stroke="#1b2d8e" strokeWidth="2" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Vision</h3>
              <p>Building a world-class ecosystem where developers and IT professionals disrupt industries, create equitable opportunities, and accelerate socio-economic progress.</p>
            </div>
            <div className="ab-mv-card">
              <div className="ab-mv-icon-wrap">
                <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
                  <polygon points="26,6 46,44 6,44" fill="#f0cd17" opacity="0.35"/>
                  <polygon points="26,12 42,44 10,44" fill="#f0cd17" opacity="0.6"/>
                  <polygon points="26,18 38,44 14,44" fill="#f0cd17"/>
                  <line x1="26" y1="6"  x2="26" y2="1"  stroke="#1b2d8e" strokeWidth="2.5" strokeLinecap="round"/>
                  <line x1="26" y1="1"  x2="33" y2="1"  stroke="#1b2d8e" strokeWidth="2.5" strokeLinecap="round"/>
                  <circle cx="33" cy="1" r="1.5" fill="#1b2d8e"/>
                </svg>
              </div>
              <h3>Mission</h3>
              <p>Become a house of innovation for enterprise level software solutions.
                Proactively anticipate and exceed customer expectations, establishing a new industry standard for personalized and seamless customer experiences.
                Break down barriers for all developers and IT professionals, by providing access to growth opportunities, quality mentorship, and career development programs.
                Empower developers and IT professionals with the knowledge, resources, and entrepreneurial environment.</p>
            </div>
          </div>
        </div>
      </section>
      <Whyus data={data} />
            {/* Leadership */}
      <section className="ab-leadership">
        <div className="ab-leadership-inner">
          <div className="ab-section-header">
            <span className="ab-eyebrow">Our Team</span>
            <h2>Meet the Leadership</h2>
            <p>Experienced professionals driving Visiomate's vision forward.</p>
          </div>
          <div className="ab-leaders-grid">
            {LEADERS.map(leader => (
              <div key={leader.name} className="ab-leader-card">
                <div className="ab-leader-card__photo-wrap">
                  <img src={leader.img} alt={leader.name} />
                  <span className="ab-leader-card__badge">{leader.title}</span>
                </div>
                <div className="ab-leader-card__body">
                  <h4 className="ab-leader-card__name">{leader.name}</h4>
                  <p className="ab-leader-card__credentials">{leader.credentials}</p>
                  <div className="ab-leader-card__socials">
                    <a href={leader.linkedin} target="_blank" rel="noreferrer" className="ab-leader-card__social-row">
                      <LinkedInIcon />
                      <span>Connect on LinkedIn</span>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Clients data={data} />
      <News data={data} />
    </Layout>
  )
}

export default About

export const query = graphql`
  query AboutQuery {
    arrowImage: file(relativePath: { eq: "Mask group (5).png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    arrowImageWhite: file(relativePath: { eq: "Mask group (6).png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoBlack: file(relativePath: { eq: "logo_black_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    aboutusbg: file(relativePath: { eq: "aboutusbg.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    lifeatvisiomatebg: file(relativePath: { eq: "lifeatvisiomatebg.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    KM: file(relativePath: { eq: "image 5.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    light: file(relativePath: { eq: "2-01 1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img1: file(relativePath: { eq: "1-01 1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    scale: file(relativePath: { eq: "4-01 1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img2: file(relativePath: { eq: "6-01 1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
